export const ADD_FILTER_STUDENTS = 'ADD_FILTER_STUDENTS';
export const REMOVE_FILTER_STUDENTS = 'REMOVE_FILTER_STUDENTS';

export const addFilterStudents = (key, text, exact) => {
  return ({
    type: ADD_FILTER_STUDENTS,
    key,
    text,
    exact
  })
};

export const removeFilterStudents = (key) => {
  return ({
    type: REMOVE_FILTER_STUDENTS,
    key
  })
};



// WEBPACK FOOTER //
// ./src/modules/Admin/redux/actions/filterStudents.js